import { View, Text, ScrollView, TouchableOpacity, Pressable, Dimensions, Image } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { Table, Row } from 'react-native-table-component';
import AsyncStorage from '@react-native-async-storage/async-storage';
import alert from './../alert'
import { useNavigation } from '@react-navigation/native';
import GlobalStyles from './../style';
import heatmap from '../heatmap';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let PlayerToChange = -1;
let lang = undefined;

const Roster = () => {
  const navigation = useNavigation();

  useLayoutEffect(() => {
    const handleBackButton = () => {
      navigation.navigate('MainMenu');
      navigation.navigate('HomeScreen');
    };

    navigation.setOptions({
      headerLeft: () => (
        <TouchableOpacity onPress={handleBackButton}>
          <View style={[{ flex: 1, justifyContent: 'center' }]}>
            <Image
              style={{ width: 24, height: 24, marginRight: 30 }}
              source={require('./../img/flechaLeft.png')}
            />
          </View>
        </TouchableOpacity>
      ),
      headerTitle: transl('HomeScreen.plantilla', lang)
    });
  }, [navigation]);

  const screenHeight = Dimensions.get('window').height;
  const screenWidth = Dimensions.get('window').width;

  const styles = {
    container: { flex: 1, padding: 16, paddingTop: 30, backgroundColor: '#fff' },
    // header: { height: 50, backgroundColor: '#537791' },
    header: { height: 50, backgroundColor: '#f2f2f2' },
    text: { textAlign: 'center', fontWeight: 'bold', fontSize:13 },
    row: { height: 40, backgroundColor: '#E7E6E1' }
  };

  const forceUpdate = useForceUpdate();

    //receivedData
    const [value, setvalue] = useState('');
    const readValue = () => {
      AsyncStorage.getItem('equipos')
      .then((value)=> {
        setvalue(value)
        if(value !== undefined)displayRoster(value)
      })
    }
    readValue()

    const langIndex = useSelector((state) => state.language) ?? 0
    lang = dr.idiomas[langIndex].value

    let state = { 
      tableHead: [transl('Roster.cambio',lang), transl('Roster.posicion',lang), transl('Roster.nombre',lang), transl('Roster.precision',lang), transl('Roster.reflejos',lang), transl('Roster.manejo',lang), transl('Roster.fuerza',lang), transl('Roster.resistencia',lang), transl('Roster.vision',lang), transl('Roster.comunicacion',lang), transl('Roster.velocidad',lang), transl('Roster.maniobra',lang), transl('Roster.estabilidad',lang),transl('Roster.vender',lang)],
      widthArr: [60, 70, 120, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 60]
    }

    const [scrollEnabled, setScrollEnabled] = useState(true);

  return (
    <View>
      <View style={{flexDirection:"row", marginHorizontal:10, marginVertical: 10,justifyContent: 'center', alignItems: 'center'}}>
        <View style={[{flex:1,marginRight:0,justifyContent:'center'}, GlobalStyles.buttonShadow]}>
          <Pressable
            style={GlobalStyles.buttonMain}
            onPress={() => navigation.navigate('AssignBroom',value)}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Roster.asignarEscoba',lang)}</Text>
          </Pressable>
        </View>
        <View style={[{flex:1,marginHorizontal:5,justifyContent:'center'}, GlobalStyles.buttonShadow]}>
          <Pressable
            style={GlobalStyles.buttonMain}
            onPress={() => navigation.navigate('Statistics',value)}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Roster.estadisticas',lang)}</Text>
          </Pressable>
        </View>
        <View style={[{flex:1,marginLeft:0}, GlobalStyles.buttonShadow]}>
          <Pressable
            style={GlobalStyles.buttonMain}
            onPress={() => navigation.navigate('Grageas',value)}>
            <Text style={GlobalStyles.textForButtonMain}>{transl('Roster.grageas',lang)}</Text>
          </Pressable>
        </View>
      </View>
      <View>
        <ScrollView horizontal={true} style={{height:screenHeight-146}}>
          <View>
            <Table borderStyle={{borderWidth: 1, borderColor: '#C1C0B9'}}>
                <Row data={state.tableHead} widthArr={state.widthArr} style={styles.header} textStyle={styles.text}/>
            </Table>
            {/* <ScrollView horizontal={true} scrollEnabled={false}>
              <Table>
                <TableWrapper style={{ flexDirection: 'row' }}>
                  <Cell
                    key={-1}
                    data={state.tableHead[0]} // Render the first column header
                    width={state.widthArr[0]}
                    style={[styles.header, { backgroundColor: '#ffffb3' }]}
                    textStyle={styles.text}
                  />
                </TableWrapper>
              </Table>
            </ScrollView> */}
            <ScrollView horizontal={false}>
              <TouchableOpacity activeOpacity={1.5}>
                <Table>
                  {
                    displayRoster(value)
                  }
                </Table>
              </TouchableOpacity>
            </ScrollView>
          </View>
        </ScrollView>
      </View>
    </View>
  )

  function displayRoster(data) {
    if(data === undefined || !data) {
      return <Image style={{width:screenWidth,height:screenWidth*0.6}} source={require('./../img/loading.gif')} />
    }
    if(typeof data != "object")data = data != null ? JSON.parse(data) : null
    //console.log(data.teams[0].players.length)
    
    const tableData = [];
    const myPlayers = data.teams[0].players;
    let isInjured = []
    for (let i = 0; i < myPlayers.length; i += 1) {
      let rowData = [];
      //añadimos boton para cambiar de posicion al jugador
      if(PlayerToChange === i){
      rowData.push(<Pressable
        style={GlobalStyles.buttonChangingPlayer}
        onPress={() => {if(changePlayer(i, data)) {forceUpdate()}}}>
        <Text style={[GlobalStyles.textForButtonMain]}>X</Text>
      </Pressable>)
      } else {
        rowData.push(<Pressable
          style={GlobalStyles.buttonChangePlayer}
          onPress={() => {if(changePlayer(i, data)) {forceUpdate()}}}>
          <Text style={GlobalStyles.textForButtonMain}>*</Text>
        </Pressable>)
      }
  
      if(i==0)rowData.push(transl('Roster.guardian',lang))
      else if(i==1 || i==2)rowData.push(transl('Roster.golpeador',lang))
      else if(i==3 || i==4)rowData.push(transl('Roster.cazador',lang))
      else if(i==5)rowData.push(transl('Roster.cazadorDelantero',lang))
      else if(i==6)rowData.push(transl('Roster.buscador',lang))
      else if(i==7)rowData.push("G. Sup.")
      else if(i==8 || i==9)rowData.push("G. Sup.")
      else if(i==10 || i==11)rowData.push("C. Sup.")
      else if(i==12)rowData.push("CD. Sup.")
      else if(i==13)rowData.push("B. Sup.")
      else rowData.push("---")

      if(myPlayers[i].injury > 0) rowData[rowData.length-1] = transl('Roster.lesion',lang)

      isInjured.push(myPlayers[i].injury > 0)

      rowData.push(myPlayers[i].name)
      for (let j = 0; j < 7; j++) {
        rowData.push(heatmap(myPlayers[i].skills[j]));
      }
      for (let j = 0; j < 3; j++) {
        rowData.push(heatmap(myPlayers[i].broom[j]))
      }
      

      if (i > 13) {
        rowData.push(<Pressable
          style={GlobalStyles.buttonSellPlayer}
          onPress={() => {sellPlayer(i, data,navigation, forceUpdate);forceUpdate()}}>
          <Text style={GlobalStyles.textForButtonMain}>$$$</Text>
        </Pressable>)
      } //else if (i > 6) rowData.push(<Text style={{textAlign:'center'}}>Suplente</Text>);
      //else rowData.push(<Text style={{textAlign:'center'}}>Titular</Text>);
      
      tableData.push(rowData);
    }

    const myBrooms = data.others.brooms;
    for (let i = 0; i < myBrooms.length; i++) {
      let rowData = [];
      rowData.push("---")
      rowData.push(<Image style={{width:30,height:30,marginLeft:'auto',marginRight:'auto'}} source={require('./../img/broomIcon.png')}/>)
      rowData.push(myBrooms[i].name)
      rowData.push("---")
      rowData.push("---")
      rowData.push("---")
      rowData.push("---")
      rowData.push("---")
      rowData.push(heatmap(myBrooms[i].velocidad))
      rowData.push(heatmap(myBrooms[i].maniobra))
      rowData.push(heatmap(myBrooms[i].estabilidad))
      rowData.push("---")
      tableData.push(rowData)
    }
  
    return tableData.map((rowData, index) => (
      <Row
        key={index}
        data={rowData}
        widthArr={state.widthArr}
        textStyle={{textAlign:'center'}}
        style={
          [index%2 && {backgroundColor: '#ffffff'},
          index==0 && {backgroundColor: '#ffffb3'},
          (index==1 || index==2) && {backgroundColor: '#b3ffff'},
          (index==3 || index==4) && {backgroundColor: '#ffb3ff'},
          index==5 && {backgroundColor: '#ff80ff'},
          (index==6) && {backgroundColor: '#ffff66', borderBottomColor:'#000',borderBottomWidth:2},
          index==7 && {backgroundColor: '#ffffe6'},
          (index==8 || index==9) && {backgroundColor: '#e6ffff'},
          (index==10 || index==11) && {backgroundColor: '#ffe6ff'},
          index==12 && {backgroundColor: '#ffccff'},
          (index==13) && {backgroundColor: '#ffffb3', borderBottomColor:'#000',borderBottomWidth:4},
          (isInjured[index]) && {backgroundColor: '#ff0000',textColor:'#fff'},
          (isInjured[index] && index%2) && {backgroundColor: '#ff3333',textColor:'#fff'},
          {paddingVertical:4}]
        }
      />
    ))
  }


  
}

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => value + 1); // update state to force render
  // An function that increment 👆🏻 the previous state like here 
  // is better than directly setting `value + 1`
}

function changePlayer(buttonPressed, data){
  //if playerchange is -1, there is no player selected
  if(PlayerToChange === -1){
    //no hay jugadores seleccionados, seleccionamos el pasado por parametros
    PlayerToChange = buttonPressed;
  } else {
    //hay un jugador seleccionado, lo cambiamos (y lo suyo seria actualizar los datos)
    const firstChange = data.teams[0].players[PlayerToChange]
    data.teams[0].players[PlayerToChange] = data.teams[0].players[buttonPressed]
    data.teams[0].players[buttonPressed] = firstChange;
    saveData(data);

    PlayerToChange = -1;
  }
  //please re-render screen so we can see the change
  //displayRoster(data);
  return true
}

function sellPlayer(i, data, navigation,forceUpdate){
  //para que no moleste, reseteamos los cambios
  PlayerToChange = -1;

  const price = Math.ceil(data.teams[0].players[i].skills[0] * 0.8
  + data.teams[0].players[i].skills[1] * 0.8
  + data.teams[0].players[i].skills[2] * 0.8
  + data.teams[0].players[i].skills[3] * 0.8
  + data.teams[0].players[i].skills[4] * 0.8
  + data.teams[0].players[i].broom[0] * 0.8
  + data.teams[0].players[i].broom[1] * 0.8
  + data.teams[0].players[i].broom[2] * 0.8)


  alert(transl('General.warning',lang),transl('Roster.quieresVender',lang,[data.teams[0].players[i].name,price]),[
    {text: transl('General.No',lang),onPress: () => void(0),style: "cancel"},
    {
      text: transl('General.Si',lang),
      onPress: () => {
        if(data.teams[0].players.length > 7){
          data.teams[0].players.splice(i,1)
          data.profile.money = data.profile.money + price
          saveData(data)
          forceUpdate()
        } else {
          alert(transl('General.warning',lang),transl('Roster.noPuedesVender',lang),[
            {text: transl('General.OK',lang),onPress: () => void(0),style:"cancel"}
          ])
        }
      }
    }
  ])

}

function saveData(data){
  const storeData = async (data) => {
    try {
      const jsonValue = JSON.stringify(data)
      await AsyncStorage.setItem('equipos', jsonValue)
    } catch (e) {
      console.log("error saving file")
      console.log(e)
    }
  }

  storeData(data);
}


export default Roster


